import { Modal, Button, Form, Image } from "react-bootstrap";
import { useState } from "react";
import { Link } from "react-router-dom";
import { MdLockOutline } from "react-icons/md";
import { submitConsent } from "../../services/Networkcall";
import { errorAlert, successAlert } from "./Alert";
import { Loader } from "./Loader";

export const LegalConsentModal = ({ show, onClose, assignmentIds }) => {
    const [agreed, setAgreed] = useState(false);
    const [loading, setLoading] = useState(false)

    const submitHandler = async (type) => {
        let action = "";
        if (type === "accept" && agreed) { action = "ACCEPTED" }
        if (type === "declined") { action = "DECLINED" }


        setLoading(true);

        const payload = {
            "consentType": "LEGAL_DOCUMENT",
            "action": action,
            "assignmentIds": assignmentIds || [],
        }

        const res = await submitConsent(payload);

        if (res?.success) {
            setLoading(false);
            successAlert({ message: res?.message })
            onClose();
        } else {
            errorAlert({ message: res?.message || "something went wrong" })
        }
        setLoading(false);
    }

    return (<>
        <Loader show={loading} />
        <Modal show={show} onHide={onClose} centered backdrop="static" dialogClassName="legal-modal">
            <Modal.Body className="p-4 text-center">

                <div className="mb-4 mt-4">

                    <span className="agreement-icon">
                        <Image src={'../../assets/images/agreement_icon.png'} height={70} width={70} className="ps-2" />
                    </span>

                    <h3 className="fw-bold mt-4 mb-3">Review Updated Terms</h3>

                    <small>We've updated our License Agreement, Platform EULA, and Privacy Policy to improve our services and keep your account secure.</small>

                    <div className="d-flex gap-2 my-2">
                        <span className="shielded-lock-icon px-2 py-2 mt-3">
                            <Image src={'../../assets/images/shielded-lock.png'} height={25} width={25} className="mt-1" />
                        </span>
                        <p className="mt-3 mb-0 text-start">Please review and accept the updated terms to continue using TruckTuck.</p>
                    </div>

                </div>

                <div className="border rounded-4 p-3 text-start mb-4">
                    <Form.Check
                        type="checkbox"
                        id="agree"
                        checked={agreed}
                        onChange={(e) => setAgreed(e.target.checked)}
                        className="small"
                        label={<span>I have read and agree to the updated
                            <Link to={'https://www.trucktuck.com/truck-parking-agreement'} target="_blank" rel="noopener noreferrer" className="text-primary fw-semibold"> License Agreement</Link> ,
                            <Link to={'https://www.trucktuck.com/eula'} target="_blank" rel="noopener noreferrer" className="text-primary fw-semibold"> Platform EULA</Link> and
                            <Link to={'https://www.trucktuck.com/privacy-policy'} target="_blank" rel="noopener noreferrer" className="text-primary fw-semibold"> Privacy Policy</Link>.
                        </span>}
                    />
                </div>

                <div className="d-grid gap-3 mb-2">

                    <Button
                        size="md"
                        disabled={!agreed}
                        onClick={() => { submitHandler("accept") }}
                        className="fw-bold"
                    >Accept & Continue </Button>
                    <Button
                        size="md"
                        variant="outline-secondary"
                        onClick={() => { submitHandler("declined") }}
                        className="fw-bold"
                    >Review Later</Button>
                </div>
                <small className="fw-bold"><MdLockOutline className="me-1" /> Your privacy and security are important to us.</small>
            </Modal.Body>
        </Modal>
    </>);
};





